import { useCart } from "../../context/CartContext";
import { Modal } from "../ui/Modal";
import { CartPanel } from "./CartPanel";

export const CartDrawer = () => {
  const { isCartOpen, closeCart } = useCart();

  return (
    <Modal open={isCartOpen} onClose={closeCart} variant="drawer" labelledBy="cart-drawer-title">
      <CartPanel titleId="cart-drawer-title" onClose={closeCart} />
    </Modal>
  );
};
